import React from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { Switch } from '@rsos/components/capstone/base';
import { selectCapstoneAudioSettingsForFeature } from '@rsos/sinatra/src/selectors/selectAudioSettings';
import useIsIRP from '@rsos/utils/useIsIRP';
import { AdminDispatch } from '../../../../app/store';
import { usePatchAudioSettings } from '../../app/patchAudioSettings';
import RepeatSelect from '../RepeatSelect';
import SoundSelect from '../SoundSelect';
import {
  trackToggleSoundOnOff,
  trackToggleRepeatAlertSound,
} from '../audioSettingsTrackings';
import styles from '../settings.module.css';

export const Agent511AudioSettings = () => {
  const dispatch = useDispatch<AdminDispatch>();
  const agent511settings = useSelector(
    selectCapstoneAudioSettingsForFeature('tt911'),
  );

  const {
    repeat_times: repeatTimes,
    repeat: isRepeatOn,
    sound_on: isSoundOn,
    tone,
  } = agent511settings;

  const patchAudioSettings = usePatchAudioSettings('tt911');
  const updateAudioSettings = (update: Partial<typeof agent511settings>) => {
    dispatch(patchAudioSettings(update));
  };

  const { irpVersion } = useIsIRP();
  const toggleSoundOn = () => {
    updateAudioSettings({ sound_on: !isSoundOn });
    trackToggleSoundOnOff(irpVersion, isSoundOn, 'tt911');
  };
  const toggleRepeatSound = () => {
    updateAudioSettings({ repeat: !isRepeatOn });
    trackToggleRepeatAlertSound(irpVersion, isRepeatOn);
  };

  return (
    <div className={styles.card}>
      <div>
        <div className={styles.cardTitle}>Agent 511</div>
        <div className={styles.cardDescription}>
          Notify your agents with sound when new text messages from Agent511
          appear in the queue.
        </div>
      </div>
      <div className={styles.soundBlock}>
        <span>Sound Notification</span>
        <Switch onOffLabel onClick={toggleSoundOn} isOn={isSoundOn} />
      </div>
      <SoundSelect
        isSoundOn={isSoundOn}
        type={'tt911'}
        tone={tone}
        updateAudioSettings={updateAudioSettings}
      />
      <span>
        The sound will repeat for each agent until selected or repeat number
        reached.
      </span>
      <div className={cn(styles.soundBlock, { disabled: !isSoundOn })}>
        <span>Repeat Sound</span>
        <Switch
          onOffLabel
          disabled={!isSoundOn}
          onClick={toggleRepeatSound}
          isOn={isRepeatOn}
        />
      </div>
      <RepeatSelect
        isDisabled={!isRepeatOn || !isSoundOn}
        repeatTimes={repeatTimes}
        updateAudioSettings={updateAudioSettings}
      />
    </div>
  );
};
